var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    attrs: {
      "collapse-id": "linked-apps-card",
      "store-path": "linkedApplications",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("application.clientApplications"))),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "add-client-modal",
              _vm._b(
                {
                  ref: "addClient",
                  attrs: { id: "add-client-from-linked-app" },
                  on: { hidden: _vm.resetData },
                },
                "add-client-modal",
                _vm.modalData,
                false
              )
            ),
            _vm._v(" "),
            _vm.username
              ? _c(
                  "linked-applications-info",
                  _vm._b(
                    {
                      attrs: { "has-applications": _vm.hasApplications },
                      on: {
                        create: _vm.handleCreate,
                        "duplicate-modal-opened": _vm.handleOpenDuplicateModal,
                        save: _vm.handleSave,
                        "copy-application": _vm.handleCopyApplication,
                      },
                    },
                    "linked-applications-info",
                    Object.assign({}, _vm.$props),
                    false
                  )
                )
              : !_vm.loadingProfileDetails
              ? _c(
                  "empty-application-handler",
                  _vm._b(
                    { on: { create: _vm.handleCreate, save: _vm.handleSave } },
                    "empty-application-handler",
                    Object.assign({}, _vm.$props),
                    false
                  )
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }